var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-page",attrs:{"id":"error-pages"}},[(_vm.is404)?_c('not-found'):_c('maintenance')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }